import { Typography } from 'antd';
import dayjs from 'dayjs';
import React, { FC } from 'react';
import styled from 'styled-components';
import { DateTimeFormat } from '~/constants/dateTime';
import longdash from '~/constants/longdash';
import { useDirection } from '~/hooks/i18nHooks';
import direction from '~/utils/direction';
import { SaudiReyalSymbolIcon } from '~/img';

/** Replace {SAR} token in a label string with the Saudi Riyal SVG icon */
function renderLabelWithSarIcon(label: string): React.ReactNode {
  if (!label.includes('{SAR}')) return label;
  const parts = label.split('{SAR}');
  return (
    <>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {part}
          {i < parts.length - 1 && (
            <SaudiReyalSymbolIcon
              className="sar-icon"
            />
          )}
        </React.Fragment>
      ))}
    </>
  );
}

interface Props {
  label: string;
  format?: 'date';
  children?: React.ReactNode;
}

const ReviewItem: FC<Props> = (props) => {
  const { children, label, format } = props;
  const dir = useDirection();

  let formattedChildren: any = children;
  if (children) {
    if (format === 'date') {
      formattedChildren = dayjs(children as string).format(DateTimeFormat.DATE);
    }
  }
  return (
    <Container dir={dir}>
      <span>
        <Typography.Title level={5} className="ReviewItemTitle">
          {typeof label === 'string' ? renderLabelWithSarIcon(label) : label}
        </Typography.Title>
        <Typography.Paragraph>
          {children === undefined || children === null || children === ''
            ? longdash
            : formattedChildren}
        </Typography.Paragraph>
      </span>
    </Container>
  );
};

const Container = styled.div`
  ${direction.padding.left(24)};
  padding-bottom: 8px;

  .ReviewItemTitle {
    margin-bottom: 8px;
  }
  .sar-icon {
    display: inline-block;
    vertical-align: middle;
    margin: 0 1px;
  }
`;

export default ReviewItem;
